module.exports = __webpack_public_path__ + "dark_card.svg?284f2d1f70f7ccd52f5569dfc75a549f";